export const hostname = (value) => {
    const url = new URL(value);
    return url.hostname;
};
